import { render, staticRenderFns } from "./Noticed.vue?vue&type=template&id=b58f870a&scoped=true"
import script from "./Noticed.vue?vue&type=script&lang=js"
export * from "./Noticed.vue?vue&type=script&lang=js"
import style0 from "./Noticed.vue?vue&type=style&index=0&id=b58f870a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58f870a",
  null
  
)

export default component.exports